<template>
  <div class="breakdown">
    <h4>{{ title }}</h4>
    <table v-if="rows.length > 0">
      <thead>
        <tr>
          <th class="name">{{ firstColumn }}</th>
          <th class="count" title="Publications mesurées">Pub.</th>
          <th class="bar-column">Impressions</th>
          <th v-for="metric in otherMetrics" :key="metric.key" class="number hide-for-mobile" :title="metric.label">{{ shortLabel(metric) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.key" :class="{faint: row.averages.count < 3}" :title="row.averages.count < 3 ? 'Peu de publications : à prendre comme une indication' : undefined">
          <td class="name">{{ row.label }}</td>
          <td class="count">{{ row.averages.count }}</td>
          <td class="bar-column">
            <span class="bar" aria-hidden="true"><i :style="{width: barWidth(row.averages.impressions) + '%'}"></i></span>
            <span class="number">{{ formatAverage(row.averages.impressions) }}</span>
          </td>
          <td v-for="metric in otherMetrics" :key="metric.key" class="number hide-for-mobile">{{ formatAverage(row.averages[metric.key]) }}</td>
        </tr>
      </tbody>
    </table>
    <p v-else class="empty">Pas encore de résultats pour cette comparaison.</p>
  </div>
</template>

<script>
import {METRICS, formatAverage} from "@/marketing/utils";

const SHORT_LABELS = {reactions: 'Réact.', comments: 'Comm.', shares: 'Part.', clicks: 'Clics', leads: 'Demandes'};

/**
 * Moyennes des résultats par catégorie (intention, rythme, modèle, image) : une ligne par catégorie, la barre compare les impressions moyennes.
 * rows : [{key, label, averages}] ; une catégorie de moins de trois publications est estompée (une moyenne sur si peu n'est qu'une indication).
 */
export default {
  name: 'PerformanceBreakdown',
  props: ['title', 'firstColumn', 'rows'],
  data() {
    return {otherMetrics: METRICS.filter(metric => metric.key !== 'impressions')};
  },
  computed: {
    maxImpressions() {
      return Math.max(0, ...this.rows.map(row => row.averages.impressions ?? 0));
    },
  },
  methods: {
    formatAverage,
    shortLabel(metric) {
      return SHORT_LABELS[metric.key] ?? metric.label;
    },
    barWidth(value) {
      return typeof value === 'number' && this.maxImpressions > 0 ? Math.round(value * 100 / this.maxImpressions) : 0;
    },
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h4
  margin 0 0 8px
  color THEME_COLOR_PRIMARY
  font-size 0.95em
  text-transform uppercase

table
  width 100%
  border-collapse collapse
  font-size 14px

th
  padding 6px 8px
  border-bottom 2px solid THEME_COLOR_PRIMARY
  color THEME_COLOR_PRIMARY
  font-size 0.85em
  text-align right

td
  padding 6px 8px
  border-bottom 1px solid PAGE_RULE_SOFT
  color #3f3931
  text-align right
  font-variant-numeric tabular-nums

.name
  text-align left !important
  font-weight 600

.count
  width 1%
  white-space nowrap

.bar-column
  min-width 150px
  white-space nowrap

  .bar
    display inline-block
    width 70px
    height 8px
    margin-right 8px
    border-radius 4px
    background rgba(36, 57, 107, 0.12)
    overflow hidden
    vertical-align middle

    i
      display block
      height 100%
      background THEME_COLOR_PRIMARY

.number
  white-space nowrap

.faint td
  opacity 0.6

.empty
  margin 0
  color CTRL_TEXT_MUTED
  font-size 0.9em

@media (max-width: 760px)
  .hide-for-mobile
    display none
</style>
